<template>
  <div
    class="pt-3 container-fluid"
    :class="
      transactionType === 'sale'
        ? 'sale-background'
        : transactionType === 'quote'
        ? 'quote-background'
        : transactionType === 'chalan' && customerChalanType === false
        ? 'chalan-background'
        : 'inward-chalan-background'
    "
  >
    <div class="row">
      <div class="pl-0 col-4">
        <div class="card-wrapper">
          <div class="mb-2 card">
            <div class="card-header">
              <div class="pl-0 col-md-12">
                <el-radio-group v-model="transactionType" fill="#5e72e4">
                  <el-radio-button
                    v-for="(item, index) in selectOptions"
                    :label="item.value"
                    :key="index"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
                <!-- ------------------for quotation--------------- -->
                <div v-if="transactionType === 'quote'">
                  <el-radio
                    :disabled="
                      $route.meta.mode === 'edit-user-quotation' ||
                      $route.meta.mode === 'edit-quote'
                        ? true
                        : false
                    "
                    v-model="quotationUser"
                    label="customer"
                    >Customer</el-radio
                  >
                  <el-radio
                    v-model="quotationUser"
                    :disabled="
                      $route.meta.mode === 'edit-user-quotation' ||
                      $route.meta.mode === 'edit-quote'
                        ? true
                        : false
                    "
                    label="serviceRequest"
                    >Service Request</el-radio
                  >
                </div>
                <!-- ------------------end for quotation--------------- -->

                <!-- ------------------for chalan--------------- -->
                <div v-if="transactionType === 'chalan'">
                  <el-radio v-model="chalanUser" label="customer"
                    >Customer</el-radio
                  >
                  <!-- :disabled="
                      $route.meta.mode === 'edit-user-quotation' ||
                      $route.meta.mode === 'edit-quote'
                        ? true
                        : false
                    " -->
                  <el-radio v-model="chalanUser" label="serviceRequest"
                    >Service Request</el-radio
                  >
                  <!-- :disabled="
                      $route.meta.mode === 'edit-user-quotation' ||
                      $route.meta.mode === 'edit-quote'
                        ? true
                        : false
                    " -->
                </div>
                <!-- ------------------end for chalan--------------- -->
              </div>
            </div>
          </div>
          <div
            v-if="transactionType === 'quote' || transactionType === 'chalan'"
            class="mb-2 card"
          >
            <div class="card-header">
              <div class="row">
                <div class="col-12">
                  <h3
                    v-if="
                      (transactionType === 'quote' &&
                        quotationUser === 'serviceRequest') ||
                        (transactionType === 'chalan' &&
                          chalanUser === 'serviceRequest')
                    "
                    class="mb-0"
                    style="text-transform: capitalize"
                  >
                    Service Request Details
                  </h3>
                  <h3 v-else class="mb-0" style="text-transform: capitalize">
                    Customer Details
                  </h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <base-input
                    v-if="
                      transactionType === 'chalan' &&
                        $route.meta.mode === 'edit-chalan'
                    "
                    label="Chalan Number"
                  >
                    <i v-if="chalanLoader" class="fas fa-spinner fa-spin" />
                    <span v-else>
                      {{ selectedChalanNumber }}
                    </span>
                  </base-input>

                  <base-input
                    v-if="
                      transactionType === 'quote' &&
                        $route.meta.mode === 'edit-quote'
                    "
                    label="Quotation Number"
                  >
                    <i v-if="quotationLoader" class="fas fa-spinner fa-spin" />
                    <span>
                      {{ selectedQuotationNumber }}
                    </span>
                  </base-input>

                  <base-input
                    v-if="
                      transactionType === 'chalan' &&
                        $route.meta.mode === 'edit-chalan'
                    "
                    label="Selected Service Request"
                  >
                    <i v-if="chalanLoader" class="fas fa-spinner fa-spin" />
                    <span>
                      {{ selectedServiceRequest }}
                    </span>
                  </base-input>
                  <base-input
                    v-else-if="
                      transactionType === 'quote' &&
                        $route.meta.mode === 'edit-quote'
                    "
                    label="Selected Service Request"
                  >
                    <i v-if="quotationLoader" class="fas fa-spinner fa-spin" />

                    <span v-else>
                      {{ selectedServiceRequest }}
                    </span>
                  </base-input>

                  <span
                    v-else-if="
                      (transactionType === 'quote' &&
                        quotationUser === 'customer') ||
                        (transactionType === 'chalan' &&
                          chalanUser === 'customer')
                    "
                  >
                    <div class="row">
                      <div class="col-6">
                        <base-input label="Customer By Name" tabindex="0">
                          <el-select
                            v-model="userId"
                            ref="customerInput"
                            @change="handleUserSelect"
                            filterable
                            clearable
                            remote
                            :remote-method="filterUserByName"
                            :loading="loading"
                          >
                            <div v-if="filteredUsers.length > 0">
                              <el-option
                                v-for="(item, index) in filteredUsers"
                                :key="index"
                                :value="item.userId"
                                :label="
                                  item.firstName +
                                    ' ' +
                                    item.lastName +
                                    ' (' +
                                    item.phone +
                                    ')'
                                "
                              />
                            </div>
                          </el-select>
                        </base-input>
                      </div>
                      <div class="col-6">
                        <base-input label="Customer By Phone" tabindex="0">
                          <el-select
                            v-model="userId"
                            ref="customerInput"
                            @change="handleUserSelect"
                            filterable
                            clearable
                            remote
                            :remote-method="filterUserByPhone"
                            :loading="loading"
                          >
                            <div v-if="filteredUsers.length > 0">
                              <el-option
                                v-for="(item, index) in filteredUsers"
                                :key="index"
                                :value="item.userId"
                                :label="
                                  item.firstName +
                                    ' ' +
                                    item.lastName +
                                    ' (' +
                                    item.phone +
                                    ')'
                                "
                              />
                            </div>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                  </span>
                  <base-input v-else label="Search Service Request">
                    <el-autocomplete
                      v-uppercase
                      ref="serviceRequestNumber"
                      v-model="selectedServiceRequest"
                      :fetch-suggestions="serviceRequestSuggestions"
                      :trigger-on-focus="false"
                      class="product-search"
                      placeholder="Search"
                      tabindex="1"
                      @select="handleServiceRequest"
                    >
                      <template slot-scope="{ item }"
                        >{{ item.serviceRequestNumber }} ({{
                          item.users.firstName +
                            " " +
                            item.users.lastName +
                            "-- " +
                            item.vendor.firstName +
                            " " +
                            item.vendor.lastName
                        }})</template
                      >
                    </el-autocomplete>
                  </base-input>

                  <base-input
                    v-if="
                      transactionType === 'quote' &&
                        $route.meta.mode === 'edit-quote'
                    "
                    label="Quotation Type"
                  >
                    <i v-if="quotationLoader" class="fas fa-spinner fa-spin" />
                    <span v-else>
                      <div class="col-md-12">
                        <div class="col-md-6">
                          <base-input label="Customer By Name" tabindex="0">
                            <el-select
                              v-model="user.userId"
                              ref="customerInput"
                              @change="handleUserSelect"
                              filterable
                              clearable
                              remote
                              :remote-method="filterUserByName"
                              :loading="loading"
                            >
                              <div v-if="filteredUsers.length > 0">
                                <el-option
                                  v-for="(item, index) in filteredUsers"
                                  :key="index"
                                  :value="item.userId"
                                  :label="
                                    item.firstName +
                                      ' ' +
                                      item.lastName +
                                      ' (' +
                                      item.phone +
                                      ')'
                                  "
                                />
                              </div>
                            </el-select>
                          </base-input>
                        </div>

                        <div class="col-md-6">
                          <base-input label="Customer By Phone" tabindex="0">
                            <el-select
                              v-model="user.userId"
                              ref="customerInput"
                              @change="handleUserSelect"
                              filterable
                              clearable
                              remote
                              :remote-method="filterUserByPhone"
                              :loading="loading"
                            >
                              <div v-if="filteredUsers.length > 0">
                                <el-option
                                  v-for="(item, index) in filteredUsers"
                                  :key="index"
                                  :value="item.userId"
                                  :label="
                                    item.firstName +
                                      ' ' +
                                      item.lastName +
                                      ' (' +
                                      item.phone +
                                      ')'
                                  "
                                />
                              </div>
                            </el-select>
                          </base-input>
                        </div>
                      </div>
                      {{ quotationType }}
                    </span>
                  </base-input>
                  <!-- {{ chalanStatus }} -->
                  <base-input
                    v-if="transactionType === 'chalan'"
                    label="Select Status For Chalan"
                  >
                    <i v-if="chalanLoader" class="fas fa-spinner fa-spin" />
                    <el-select
                      v-else
                      v-model="chalanStatus"
                      :disabled="chalanStatusCode === 'accepted'"
                    >
                      <el-option
                        v-for="(item, index) in chalanStatuses"
                        :key="index"
                        :value="item.statusId"
                        :label="item.label"
                        :disabled="item.code === 'accepted'"
                      />
                    </el-select>
                  </base-input>

                  <base-input
                    v-if="
                      transactionType === 'chalan' && chalanUser === 'customer'
                    "
                    label="Select Chalan Type"
                  >
                    <el-radio v-model="customerChalanType" :label="true"
                      >Inward</el-radio
                    >
                    <el-radio v-model="customerChalanType" :label="false"
                      >Outward</el-radio
                    >
                  </base-input>

                  <base-input
                    v-if="transactionType === 'quote'"
                    label="Select Status For Quotation"
                  >
                    <i v-if="quotationLoader" class="fas fa-spinner fa-spin" />
                    <el-select
                      v-else
                      v-model="quotationStatus"
                      :disabled="quotationStatusCode === 'accepted'"
                    >
                      <el-option
                        v-for="(item, index) in quotationStatuses"
                        :key="index"
                        :value="item.statusId"
                        :label="item.label"
                      />
                      <!-- :disabled="item.code === 'accepted'" -->
                    </el-select>
                  </base-input>

                  <base-input
                    v-if="
                      transactionType === 'chalan' &&
                        chalanUser === 'serviceRequest'
                    "
                    label="Chalan Type"
                  >
                    <span v-if="$route.meta.mode === 'edit-chalan'">
                      <i v-if="chalanLoader" class="fas fa-spinner fa-spin" />
                      <span v-else>
                        {{ chalanType | formatChalanType }}
                      </span>
                    </span>
                    <el-select v-else v-model="chalanType">
                      <el-option
                        v-for="(item, index) in chalanTypes"
                        :key="index"
                        :value="item.value"
                        :label="item.label"
                      />
                    </el-select>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
          <!-- customer or service details box -->
          <div v-if="transactionType === 'sale'" class="mb-2 card">
            <div class="flex justify-between p-2">
              <div class="">
                <h3 class="mb-0" style="text-transform: capitalize">
                  {{ userType }}
                </h3>
              </div>
              <div class="text-right">
                <base-button size="sm" type="primary" @click="createCounterSale"
                  >Counter Sale</base-button
                >
                <base-button size="sm" type="primary" @click="createUser"
                  >Add New</base-button
                >
              </div>
            </div>

            <!--Customer Card body -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Customer By Name" tabindex="0">
                    <el-select
                      v-model="sale.userId"
                      ref="customerInput"
                      @change="handleUserSelect"
                      filterable
                      clearable
                      remote
                      :remote-method="filterUserByName"
                      :loading="loading"
                    >
                      <div v-if="filteredUsers.length > 0">
                        <el-option
                          v-for="(item, index) in filteredUsers"
                          :key="index"
                          :value="item.userId"
                          :label="
                            item.firstName +
                              ' ' +
                              item.lastName +
                              ' (' +
                              item.phone +
                              ')'
                          "
                        />
                      </div>
                    </el-select>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Customer By Phone" tabindex="0">
                    <el-select
                      v-model="sale.userId"
                      ref="customerInput"
                      @change="handleUserSelect"
                      filterable
                      clearable
                      remote
                      :remote-method="filterUserByPhone"
                      :loading="loading"
                    >
                      <div v-if="filteredUsers.length > 0">
                        <el-option
                          v-for="(item, index) in filteredUsers"
                          :key="index"
                          :value="item.userId"
                          :label="
                            item.firstName +
                              ' ' +
                              item.lastName +
                              ' (' +
                              item.phone +
                              ')'
                          "
                        />
                      </div>
                    </el-select>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
          <!-- Bill Details -->
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <h3>Billing</h3>

                <div v-if="$route.meta.mode === 'edit-chalan'">
                  <el-date-picker
                    v-model="chalanDate"
                    type="date"
                    placeholder="Pick a day"
                  />
                </div>
                <div v-if="$route.meta.mode === 'edit-quote'">
                  <el-date-picker
                    v-model="quotationDate"
                    type="date"
                    placeholder="Pick a day"
                  />
                </div>
                <div
                  v-if="
                    $route.meta.mode != 'edit-chalan' &&
                      $route.meta.mode != 'edit-quote'
                  "
                >
                  <el-date-picker
                    v-model="sale.date"
                    type="date"
                    placeholder="Pick a day"
                  />
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  v-if="
                    transactionType === 'sale' || transactionType === 'quote'
                  "
                  class="col-6"
                >
                  <base-input
                    ref="discount"
                    v-model="discount"
                    :disabled="$route.meta.mode === 'edit' ? true : false"
                    tabindex="5"
                    label="Discount"
                    type="number"
                  >
                    <base-button
                      v-if="discountMode === 'percent'"
                      slot="prepend"
                      :disabled="$route.meta.mode === 'edit' ? true : false"
                      type="primary"
                      size="sm"
                      @click="discountMode = 'amount'"
                    >
                      <span class="btn-inner--text" icon="fas fa-percent">
                        <i class="fas fa-percent" />
                      </span>
                    </base-button>
                    <base-button
                      v-else
                      slot="prepend"
                      :disabled="$route.meta.mode === 'edit' ? true : false"
                      type="primary"
                      size="sm"
                      @click="discountMode = 'percent'"
                    >
                      <span class="btn-inner--text">
                        <i class="fas fa-rupee-sign" />
                      </span>
                    </base-button>
                  </base-input>
                </div>
              </div>
              <div class="row billing-summary">
                <div class="col billing-item">
                  <div class="billing-label">Total</div>
                  <div class="billing-value total-value">
                    {{ total | currency }}
                  </div>
                </div>
                <div class="col billing-item">
                  <div class="billing-label">Discount</div>
                  <div class="billing-value discount-value">
                    {{ discountAmount | currency }}
                  </div>
                </div>
                <div class="col billing-item">
                  <div class="billing-label">Round Off</div>
                  <div class="billing-value roundoff-value">
                    {{ roundOff | currency }}
                  </div>
                </div>
              </div>

              <div
                v-if="transactionType === 'sale' || transactionType === 'quote'"
                class="row amount-due-row"
              >
                <div class="text-center col-12">
                  <div class="amount-due-container">
                    <div class="amount-due-label">Amount Due</div>
                    <div class="amount-due-value">
                      {{ amountDue | currency }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- {{ sale }} -->
              <div class="row">
                <div class="pt-2 col-12">
                  <base-button
                    v-if="transactionType === 'sale'"
                    :loading="generatingSale"
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateSale()"
                    >Save Sale
                  </base-button>
                  <base-button
                    v-else-if="
                      $route.meta.mode === 'edit-quote' &&
                        transactionType === 'quote'
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generatServiceRequesteQuotation()"
                  >
                    Update Quotation
                  </base-button>
                  <base-button
                    v-else-if="$route.meta.mode === 'edit-user-quotation'"
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateUserQuotation()"
                  >
                    Update Quotation
                  </base-button>
                  <base-button
                    v-else-if="
                      transactionType === 'quote' &&
                        quotationUser === 'customer' &&
                        !this.$route.params.quotationId
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateUserQuotation()"
                  >
                    Save Quotation
                  </base-button>
                  <base-button
                    v-else-if="
                      transactionType === 'quote' &&
                        quotationUser === 'serviceRequest'
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generatServiceRequesteQuotation()"
                  >
                    Save Quotation
                  </base-button>

                  <base-button
                    v-else-if="$route.meta.mode === 'edit-chalan'"
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateChalan()"
                  >
                    Update Chalan
                  </base-button>
                  <base-button
                    v-else-if="
                      transactionType === 'chalan' &&
                        chalanUser === 'serviceRequest'
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateChalan()"
                  >
                    Save Chalan
                  </base-button>

                  <base-button
                    v-else-if="
                      transactionType === 'chalan' && chalanUser === 'customer'
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateCustomerChalan()"
                  >
                    Save Chalan
                  </base-button>

                  <base-button
                    v-else-if="
                      transactionType === 'quote' &&
                        !this.$route.params.quotationId
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generatServiceRequesteQuotation({ print: true })"
                  >
                    Save & Print
                  </base-button>
                  <base-button
                    v-else-if="
                      transactionType === 'chalan' &&
                        !this.$route.params.chalanId &&
                        !this.$route.params.customerChalanId
                    "
                    style="text-transform: capitalize"
                    type="primary"
                    @click="generateChalan({ print: true })"
                  >
                    Save & Print
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-0 col-8">
        <!-- Form controls -->
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Items ({{ selectedProducts.length }})</h3>
              </div>
              <div class="text-right col-6">
                <base-button
                  v-if="customerPriceType != null"
                  :type="
                    customerPriceType === 'Wholesale' ? 'warning' : 'success'
                  "
                  @click="changeCustomerPriceType()"
                  >{{ customerPriceType }}</base-button
                >
              </div>
            </div>
          </div>
          <div class="py-1">
            <div class="px-2" v-if="customerChalanType === true">
              <label for="">Select Products For Inward Chalan</label>
              <base-input>
                <el-select
                  ref="customerInput"
                  @change="handleProductSelect"
                  filterable
                  clearable
                >
                  <div v-if="inwardProductList.length > 0">
                    <el-option
                      v-for="(item, index) in inwardProductList"
                      :key="index"
                      :value="item"
                      :label="item.name + ' (' + item.returnableQuantity + ')'"
                    />
                  </div>
                </el-select>
              </base-input>
            </div>
            <div
              class="px-2"
              v-if="
                $route.meta.mode != 'edit-chalan' &&
                  $route.meta.mode != 'edit-quote' &&
                  customerChalanType === false
              "
            >
              <label for="">Advance Search</label>
              <base-input>
                <el-autocomplete
                  v-uppercase
                  ref="searchProduct"
                  v-model="searchKeyword"
                  :fetch-suggestions="suggestProducts"
                  :trigger-on-focus="false"
                  class="product-search"
                  value-key="name"
                  placeholder="Search Product/Barcode"
                  tabindex="4"
                  @select="handleProductSelect"
                />
              </base-input>
            </div>
            <div class="px-1 pt-1 cart">
              <h5>Name</h5>
              <h5>Price</h5>
              <h5>P. Type</h5>
              <h5>Qty</h5>
              <h5>D. Type</h5>
              <h5>Disc.</h5>
              <h5>GST</h5>
              <h5>Total</h5>
              <h5 />
            </div>
            <div v-if="chalanLoader" class="no-rows">
              <i class="fas fa-spinner fa-spin" />
            </div>
            <div v-else-if="quotationLoader" class="no-rows">
              <i class="fas fa-spinner fa-spin" />
            </div>
            <div v-else-if="selectedProducts.length === 0" class="no-rows">
              No Products Added Into The Cart
            </div>
            <div ref="scrollToMe" class="product-cart">
              <div
                v-for="(row, index) in selectedProducts"
                :key="index"
                class="product-row"
              >
                <div class="text-left grid-item">
                  <h4>{{ index + 1 }}) {{ row.name }}</h4>
                </div>
                <div class="product-price grid-item">
                  <base-input
                    v-if="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                  >
                    {{ row.price }}
                  </base-input>
                  <base-input
                    v-else
                    :min="1"
                    v-model="row.price"
                    type="number"
                    @click="calculateRowTotal"
                  />
                </div>
                <div class="product-price-type grid-item">
                  <base-button
                    :disabled="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                    :type="
                      row.priceType === 'Wholesale' ? 'warning' : 'success'
                    "
                    size="sm"
                    @click="changePriceType(row)"
                  >
                    <span class="btn-inner--text">
                      <i class="fas fa fa-circle-thin">
                        <span v-if="row.priceType === 'Wholesale'">W</span>
                        <span v-else>R</span>
                      </i>
                    </span>
                  </base-button>
                </div>
                <div class="product-qty grid-item">
                  <base-input
                    v-if="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                  >
                    {{ row.quantity }}
                  </base-input>
                  <base-input
                    v-else
                    :min="1"
                    v-model="row.quantity"
                    type="number"
                    @click="calculateRowTotal"
                  />
                </div>
                <div class="product-discount-type grid-item">
                  <base-button
                    v-if="row.productDiscount === 'percent'"
                    slot="prepend"
                    :disabled="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                    type="primary"
                    size="sm"
                    @click="
                      row.productDiscount = 'amount';
                      calculateRowTotal(row);
                    "
                  >
                    <span class="btn-inner--text" icon="fas fa-percent">
                      <i class="fas fa-percent" />
                    </span>
                  </base-button>
                  <base-button
                    v-else
                    slot="prepend"
                    :disabled="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                    type="primary"
                    size="sm"
                    @click="
                      row.productDiscount = 'percent';
                      calculateRowTotal(row);
                    "
                  >
                    <span class="btn-inner--text">
                      <i class="fas fa-rupee-sign" />
                    </span>
                  </base-button>
                </div>
                <div class="product-qty grid-item">
                  <base-input
                    v-if="
                      $route.meta.mode === 'edit-chalan' ||
                        $route.meta.mode === 'edit-quote'
                    "
                  >
                    {{ row.discount }}
                  </base-input>
                  <base-input
                    v-else
                    v-model="row.discount"
                    type="number"
                    @click="calculateRowTotal"
                  />
                </div>
                <div class="grid-item">{{ row.taxRate }}%</div>
                <div class="product-qty grid-item">
                  <span class="flex justify-between items-center">
                    <i class="fas fa-rupee-sign" />
                    {{ calculateRowTotal(row) }}
                  </span>
                </div>
                <div
                  v-if="
                    $route.meta.mode != 'edit-chalan' &&
                      $route.meta.mode != 'edit-quote'
                  "
                  class="grid-item"
                >
                  <span
                    class="cursor-pointer btn-inner--text"
                    @click="removeItem(row)"
                  >
                    <i class="el-icon-error" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="addUser" title="Add User">
      <add-user :redirect-to-users="false" @close="addUser = false" />
    </el-dialog>

    <!-- Payment Popup -->
    <payment-popup
      :show.sync="showPaymentPopup"
      :total-amount="finalAmount"
      :raw-total="total"
      :discount="discount"
      :discount-mode="discountMode"
      :round-off="roundOff"
      :amount-due="amountDue"
      :customer-name="getCustomerName"
      :selected-products="selectedProducts"
      :sale-data="sale"
      :saving="saving"
      @close="showPaymentPopup = false"
      @print="handlePrintReceipt"
      @save="handleSaveSale"
    />
    <el-dialog
      :visible.sync="addQuantity"
      :title="'Product Name - ' + currentProduct.name"
      @close="closeQuantityModal()"
    >
      <el-form @submit.prevent.native="addProduct(currentProduct)">
        <div class="row">
          <div class="col-md-6">
            <base-input label="Enter Quantity">
              <el-input
                ref="currentQuantity"
                v-model="currentProduct.currentQuantity"
                type="number"
              />
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="Available Quantity">
              {{ currentProduct.quantity }}
            </base-input>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <base-button type="primary" @click="addProduct(currentProduct)"
          >Confirm</base-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Select,
  Option,
  Radio,
  RadioGroup,
  RadioButton,
  Table,
  TableColumn,
  Autocomplete,
  DatePicker,
  Dialog,
  Form,
  MessageBox
} from "element-ui";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import AddUser from "../User/CreateUserComponent.vue";
import dateFns from "date-fns";
import PosOptions from "./PosOptions.vue";
import PaymentPopup from "../../components/PaymentPopup.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { print } from "@/utils/print";
import snakeToCamel from "../../utils/SnakeToCamel";

// import invoiceNumber from "../../store/modules/invoice";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Autocomplete.name]: Autocomplete,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    "add-user": AddUser,
    "pos-options": PosOptions,
    "payment-popup": PaymentPopup
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
    },
    formatChalanType(value) {
      if (value) {
        return "Inward Chalan";
      } else {
        return "Outward Chalan";
      }
    }
  },
  data: () => {
    return {
      billRequestId: null,
      test: true,
      saving: false,
      discount: 0,
      customerPriceType: null,
      userType: "customer",
      discountMode: "percent",
      productDiscount: "percent",
      generatingSale: false,
      searchKeyword: "",
      selectedProducts: [],
      loading: false,
      selectOptions: [
        {
          label: "Sale",
          value: "sale"
        },
        {
          label: "Quote",
          value: "quote"
        },
        {
          label: "Chalan",
          value: "chalan"
        }
      ],

      transactionType: "sale",
      user: {},
      userId: null,
      addUser: false,
      addQuantity: false,
      currentProduct: {},
      selectedServiceRequest: "",
      selectedServiceRequestData: {},
      selectedChalanNumber: "",
      chalanStatuses: [],
      chalanStatus: "",
      chalanStatusCode: "",
      customerChalanType: false,
      chalanType: "",
      chalanTypes: [
        {
          label: "Inward Chalan",
          value: true
        },
        {
          label: "Outward Chalan",
          value: false
        }
      ],
      chalanDate: "",
      selectedQuotationNumber: "",
      quotationType: "",
      quotationStatuses: [],
      quotationStatus: "",
      quotationStatusCode: "",
      quotationDate: "",
      chalanLoader: false,
      quotationLoader: false,
      quotationUser: "customer",
      chalanUser: "customer",
      filteredUsers: [],
      showPaymentPopup: false,
      roundOff: 0,
      inwardProductList: []
    };
  },

  computed: {
    ...mapState("sale", ["sale"]),
    ...mapGetters({
      products: "product/getProducts",
      users: "user/getUserList",
      customers: "user/getCustomerList",
      paymentModeList: "paymentMode/getPaymentModes",
      loggedInUser: "user/getLoggedInUser",
      sale: "sale/getSale",
      // invoiceNumber: "invoice/getInvoiceNumber",
      statusList: "status/getStatusList"
    }),
    total() {
      let total = 0;
      if (this.selectedProducts && this.selectedProducts.length > 0) {
        total = this.selectedProducts.reduce((a, b) => {
          const priceWithoutDiscount = parseFloat(b.price * b.quantity);
          let price = 0;
          let taxAmount = 0;
          let rowTotal = 0;
          if (b.productDiscount === "amount") {
            price = priceWithoutDiscount - b.discount;
          } else {
            price =
              priceWithoutDiscount - priceWithoutDiscount * (b.discount / 100);
          }
          taxAmount = parseFloat(price) * parseFloat(b.taxRate / 100);
          rowTotal = parseFloat(price) + parseFloat(taxAmount);
          return a + rowTotal;
        }, 0);
      }
      return total;
    },
    finalAmount() {
      // Calculate the amount after discount
      let amountAfterDiscount = this.total;
      if (this.discountMode === "percent") {
        amountAfterDiscount = this.total - this.total * (this.discount / 100);
      } else {
        amountAfterDiscount = this.total - this.discount;
      }

      // Round to nearest rupee
      const roundedAmount = Math.round(amountAfterDiscount);
      this.roundOff =
        Math.round((roundedAmount - amountAfterDiscount) * 100) / 100;
      return roundedAmount;
    },
    discountAmount() {
      if (this.discountMode === "percent") {
        return this.total * (this.discount / 100);
      } else {
        return this.discount;
      }
    },
    amountDue() {
      if (this.$route.meta.type !== "edit") {
        // Use final amount (after discount and rounding)
        let amountDue = this.finalAmount;
        this.sale.amountPaid = amountDue;
        return amountDue;
      } else {
        this.sale.amountPaid = this.sale.amountPaid;
        let amountDue = this.finalAmount;
        amountDue = amountDue - this.sale.amountPaid;
        return amountDue;
      }
    },

    amountRemaining() {
      let amountDue = this.amountDue;
      let remainAmount = this.sale.amountPaid;
      let amountRemaining = amountDue - remainAmount;
      return amountRemaining;
    },
    getCustomerName() {
      if (this.sale.userId) {
        const user = this.filteredUsers.find(
          u => u.userId === this.sale.userId
        );
        return user ? `${user.firstName} ${user.lastName}` : "";
      }
      return "";
    }
  },

  watch: {
    transactionType: "handleConditionForInwardChalanProducts",
    chalanUser: "handleConditionForInwardChalanProducts",
    customerChalanType: "handleConditionForInwardChalanProducts",
    addQuantity(val) {
      if (val) {
        let self = this;
        this.$nextTick().then(function() {
          self.$refs.currentQuantity.focus();
        });
      }
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.editSale(this.$route.params.id);
    }
    if (this.$route.params.userQuotationId) {
      this.editUserQuotation();
    }
    if (this.$route.params.customerChalanId) {
      this.editCustomerChalan(this.$route.params.customerChalanId);
    }
    await this.getStatuses();
    if (this.statusList.length > 0) {
      this.chalanStatuses = this.statusList.filter(
        i =>
          i.code === "pending" ||
          i.code === "dispatched" ||
          i.code === "accepted"
      );
      this.chalanStatus = this.chalanStatuses.filter(
        i => i.code === "pending"
      )[0].statusId;
      this.quotationStatuses = this.statusList.filter(
        i =>
          i.code === "pending" ||
          i.code === "dispatched" ||
          i.code === "accepted" ||
          i.code === "declined"
      );
    }
    this.getProducts();
    this.getPaymentModes();
    this.$sidebar.toggleMinimize();
    if (this.$route.meta.mode === "credit-note") {
      this.transactionType = "creditNotes";
      this.sale.saleId = this.$route.params.id;
    } else if (this.$route.meta.mode === "edit") {
      this.prepareEditMode();
    } else if (this.$route.meta.mode === "edit-chalan") {
      this.editChalanData();
    } else if (this.$route.meta.mode === "edit-quote") {
      this.editQuotation();
    } else if (this.$route.name === "merge-customer-chalans") {
      this.handleMergeCustomerChalans();
    } else {
      if (this.$route.meta.mode === "edit-bill-request") {
        this.prepareEditBillRequestMode();
      } else {
        this.resetSale();
      }
    }

    document.addEventListener("keydown", this.keyListener.bind(this));
  },
  methods: {
    ...mapActions({
      getProducts: "product/getProducts",
      getUsers: "user/getUsers",
      getProductData: "product/getProductForPos",
      getPaymentModes: "paymentMode/getPaymentModes",
      createSale: "sale/createSale",
      addCreditNotes: "sale/addCreditNotes",
      updateSale: "sale/updateSale",
      editSale: "sale/editSale",
      getServiceRequestList: "serviceRequest/getServiceRequestList",
      getServiceRequestListForPosChalan: "serviceRequest/getServiceRequestListForPosChalan",
      getStatuses: "status/getStatusList",
      createQuotation: "serviceRequestQuotation/saveQuotationFromPos",
      getUser: "user/fetchUser",
      saveChalan: "serviceRequestChalan/saveChalanFromPos",
      getChalanDetails: "serviceRequestChalan/getServiceRequestChalanDetails",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      updateServiceRequestChalanData:
        "serviceRequestChalan/updateServiceRequestChalanData",
      getQuotationData:
        "serviceRequestQuotation/getServiceRequestQuotationDetails",
      updateServiceRequestQuotation:
        "serviceRequestQuotation/updateServiceRequestQuotation",
      getReceipt: "sale/getReceipt",
      printQuotation: "serviceRequestQuotation/printQuotation",
      printChalan: "serviceRequestChalan/printChalan",
      createUserQuotation: "user/saveUserQuotation",
      getUserQuotation: "user/getUserQuotation",
      updateUserQuotation: "user/updateUserQuotation",
      searchUsers: "user/searchUsers"
    }),
    ...mapMutations({
      resetSale: "sale/resetSale",
      resetUser: "user/resetUser"
    }),
    scrollToElement() {
      const element = this.$refs.scrollToMe;
      if (element) {
        setTimeout(() => {
          element.lastElementChild.scrollIntoView({ behaviour: "smooth" });
        }, 1000);
      }
    },
    createCounterSale() {
      this.sale.userId = endpoints.COUNTER_SALE_USER_ID;
      this.filteredUsers = [
        {
          userId: endpoints.COUNTER_SALE_USER_ID,
          firstName: "Counter",
          lastName: "Sale",
          phone: "1111111111",
          preferredProductPriceType: "Retail"
        }
      ];
      this.transactionType = "sale";
      this.customerPriceType = "Retail";
    },
    changePriceType(row) {
      let result = {};
      this.selectedProducts.find(i => {
        if (i.productId === row.productId) {
          result = i.prices.find(item => {
            if (
              item.productPriceTypeLabel.toLowerCase() !=
              row.priceType.toLowerCase()
            ) {
              row.price = item.price;
              row.discount = item.defaultDiscount ? item.defaultDiscount : 0;
              row.productPriceTypeId = item.productPriceTypeId;
              return (row.priceType = item.productPriceTypeLabel);
            }
          });
        }
      });
    },

    //edit sale
    prepareEditMode() {
      this.setUser();
      this.transactionType = "sale";
      this.selectedProducts = this.sale.products;
      this.discount = this.sale.discount;
      if (this.sale.isPercentage === true) {
        this.discountMode = "percent";
      } else {
        this.discountMode = "amount";
      }
    },
    prepareEditBillRequestMode() {
      this.billRequestId = this.$route.params.billRequestId;
      this.setUser();
      this.transactionType = "sale";
      this.selectedProducts = this.sale.products;
      this.discount = this.sale.discount;
      if (this.sale.isPercentage === true) {
        this.discountMode = "percent";
      } else {
        this.discountMode = "amount";
      }
    },
    changeCustomerPriceType() {
      if (this.customerPriceType === "Wholesale") {
        this.selectedProducts.forEach(i => {
          const priceType = i.prices.find(item => {
            if (item.productPriceTypeLabel === "Retail") {
              return item;
            }
          });
          i.price = priceType.price;
          i.priceType = "Retail";
          i.discount = priceType.defaultDiscount;
        });
        this.customerPriceType = "Retail";
      } else {
        this.selectedProducts.forEach(i => {
          const priceType = i.prices.find(item => {
            if (item.productPriceTypeLabel === "Wholesale") {
              return item;
            }
          });
          i.price = priceType.price;
          i.priceType = "Wholesale";
          i.discount = priceType.defaultDiscount;
        });
        this.customerPriceType = "Wholesale";
      }
    },
    async suggestProducts(query, cb) {
      const result = await this.getProducts({ searchKeyword: query });
      cb(result.rows);
    },
    addProduct(res) {
      if (res && res.prices.length > 0) {
        let productPrice;
        productPrice = res.prices.find(i => {
          if (i.productPriceTypeLabel === this.customerPriceType) {
            return i;
          }
        });
        if (productPrice === undefined) {
          productPrice = res.prices.find(i => {
            if (i.productPriceTypeLabel != this.customerPriceType) {
              return i;
            }
          });
        }
        this.selectedProducts.push({
          productId: res.productId,
          name: res.name,
          price: productPrice.price,
          quantity:
            res.currentQuantity && res.currentQuantity > 0
              ? res.currentQuantity
              : 1,
          discount: productPrice.defaultDiscount
            ? productPrice.defaultDiscount
            : 0,
          total: productPrice.price,
          priceType: productPrice ? productPrice.productPriceTypeLabel : "--",
          productPriceTypeId: productPrice
            ? productPrice.productPriceTypeId
            : "",
          prices: res.prices,
          productDiscount: "percent",
          taxRate: res.taxRate,
          isPercentage: this.productDiscount === "percent" ? true : false
        });
        this.addQuantity = false;
        this.$refs.searchProduct.focus();
      } else {
        let productPrice;
        productPrice = res.defaultDiscountPrices.find(i => {
          if (i.productPriceTypeLabel === this.customerPriceType) {
            return i;
          }
        });
        if (productPrice === undefined) {
          productPrice = res.defaultDiscountPrices.find(i => {
            if (i.productPriceTypeLabel != this.customerPriceType) {
              return i;
            }
          });
        }
        this.selectedProducts.push({
          productId: res.productId,
          name: res.name,
          price: productPrice.price,
          quantity:
            res.currentQuantity && res.currentQuantity > 0
              ? res.currentQuantity
              : 1,
          discount: productPrice.defaultDiscount
            ? productPrice.defaultDiscount
            : 0,
          total: productPrice.price,
          priceType: productPrice ? productPrice.productPriceTypeLabel : "--",
          productPriceTypeId: productPrice
            ? productPrice.productPriceTypeId
            : "",
          prices: res.defaultDiscountPrices,
          productDiscount: "percent",
          taxRate: res.taxRate,
          isPercentage: this.productDiscount === "percent" ? true : false
        });
        this.addQuantity = false;
        this.$refs.searchProduct.focus();
      }
      this.scrollToElement();
    },
    handleProductSelect(product) {
      if (
        this.sale.userId ||
        this.selectedServiceRequest != "" ||
        this.userId
      ) {
        this.getProductData({
          productId: product.productId,
          date: dateFns.format(this.sale.date, "YYYY-MM-DD")
        }).then(res => {
          if (this.selectedProducts.length > 0) {
            const productExist = this.selectedProducts.find(
              i => i.productId === res.productId
            );
            if (productExist) {
              productExist.quantity = parseInt(productExist.quantity) + 1;
              this.searchKeyword = "";
            } else {
              if (res.productId) {
                this.currentProduct = res;
                this.addQuantity = true;
              } else {
                this.$notify({
                  message:
                    "Pricing is not available for selected product and date",
                  type: "danger",
                  title: "Error"
                });
              }
            }
          } else {
            if (res.productId) {
              this.currentProduct = res;
              this.addQuantity = true;
            } else {
              this.$notify({
                message:
                  "Pricing is not available for selected product and date",
                type: "danger",
                title: "Error"
              });
            }
          }
        });
      } else {
        this.$notify({
          message: "Please Select Customer First!",
          type: "warning",
          title: "Warning"
        });
        this.searchKeyword = "";
      }
    },
    removeItem(product) {
      //ask for confirmation
      MessageBox.confirm(
        "Are you sure you want to remove this item?",
        "Confirmation",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.selectedProducts = this.selectedProducts.filter(
            i => i.productId !== product.productId
          );
        })
        .catch(() => {
          // User cancelled the action
        });
    },
    handleUserSelect(userId) {
      const filteredUser = this.filteredUsers.find(i => i.userId === userId);
      this.customerPriceType = filteredUser.preferredProductPriceType;
      this.$refs.searchProduct.focus();
    },
    generateSale(print) {
      if (this.selectedProducts.length === 0) {
        this.$notify({
          message: "Please select products first!",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      if (!this.sale.userId) {
        this.$notify({
          message: "Please select customer first!",
          type: "warning",
          title: "Warning"
        });
        return;
      }

      // Show payment popup instead of directly saving
      this.showPaymentPopup = true;
    },
    calculateRowTotal(row) {
      let discountedAmount = 0;
      if (row.discount) {
        if (row.productDiscount === "percent") {
          row.isPercentage = true;
          discountedAmount =
            (parseFloat(row.price) *
              parseInt(row.quantity) *
              parseFloat(row.discount)) /
            100;
        } else {
          row.isPercentage = false;
          discountedAmount = parseFloat(row.discount);
        }
      }
      let sum = 0;
      let taxAmount = 0;
      let rowTotal = 0;
      sum = parseFloat(row.price) * parseInt(row.quantity) - discountedAmount;
      taxAmount = sum * (row.taxRate / 100);
      rowTotal = sum + parseFloat(taxAmount);
      return Math.round(rowTotal * 100) / 100;
    },
    createUser() {
      this.resetUser();
      this.addUser = true;
    },
    keyListener(e) {
      if (e.ctrlKey && e.key === "c") {
        this.$refs.userName.focus();
      } else if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
        this.$refs.searchProduct.focus();
      } else if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
        this.generateSale();
      }
    },
    closeQuantityModal() {
      this.searchKeyword = "";
    },
    async serviceRequestSuggestions(query, cb) {
      // If chalan and chalanUser is serviceRequest, use pos-chalan endpoint
      if (
        this.transactionType === "chalan" &&
        this.chalanUser === "serviceRequest"
      ) {
        const suggestions = await this.getServiceRequestListForPosChalan({
          number: query,
          page: 1,
          perPage: 10
        });
        cb(suggestions);
      } else {
        const suggestions = await this.getServiceRequestList({
          number: query,
          page: 1,
          perPage: 10
        });
        cb(suggestions.rows);
      }
    },
    handleServiceRequest(value) {
      // Validate service request for chalan creation
      if (
        this.transactionType === "chalan" &&
        this.chalanUser === "serviceRequest"
      ) {
        const reasons = [];
        if (value.isQuotationPending === true) {
          reasons.push("Quotation is pending");
        }
        if (value.isSiteVisited === false) {
          reasons.push("Site visit is not completed");
        }
        if (value.customerCall === false) {
          reasons.push("Customer call is not completed");
        }
        if (reasons.length > 0) {
          this.$notify({
            message: `Cannot create chalan because: ${reasons.join(", ")}`,
            type: "danger",
            title: "Validation Error",
            duration: 5000
          });
          // Clear the selection
          this.selectedServiceRequestData = {};
          this.selectedServiceRequest = "";
          return;
        }
      }

      this.selectedServiceRequestData = value;
      this.selectedServiceRequest =
        value.serviceRequestNumber +
        "(" +
        value.users.firstName +
        " " +
        value.users.lastName +
        "-- " +
        value.vendor.firstName +
        " " +
        value.vendor.lastName +
        ")";
      this.getUser(this.selectedServiceRequestData.userId).then(res => {
        this.customerPriceType = res.preferredProductPriceType;
      });
    },
    async generatServiceRequesteQuotation(isPrint) {
      if (
        this.selectedServiceRequestData &&
        this.selectedServiceRequestData.serviceRequestId
      ) {
        if (this.$route.meta.mode === "edit-quote") {
          this.updateServiceRequestQuotation({
            serviceRequestQuotationId: this.$route.params.quotationId,
            statusId: this.quotationStatus,
            serviceRequestId: this.selectedServiceRequestData.serviceRequestId,
            discount: this.discount,
            isPercentage: this.discountMode === "percent" ? true : false
          })
            .then(async () => {
              // Prepare quotation data for printing before clearing
              const quotationData = {
                products: this.selectedProducts,
                users: this.selectedServiceRequestData.users,
                vendor: this.selectedServiceRequestData.vendor,
                quotationNumber: this.$route.params.quotationId,
                total: this.total,
                discount: this.discount,
                isPercentage: this.discountMode === "percent",
                updatedAt: new Date()
              };

              this.$notify({
                message: "Quotation Status Updated!",
                type: "success",
                title: "Success"
              });

              // Ask user if they want to print
              MessageBox.confirm(
                "Quotation updated successfully! Would you like to print it?",
                "Print Quotation",
                {
                  confirmButtonText: "Yes, Print",
                  cancelButtonText: "No, Thanks",
                  type: "info"
                }
              )
                .then(() => {
                  this.printQuotation(quotationData);
                })
                .catch(() => {
                  // User cancelled printing
                });
            })
            .catch(err => {
              this.$notify({
                message: err,
                type: "danger",
                title: "Warning"
              });
            });
        } else {
          const pendingStatus = this.statusList.find(i => i.code === "pending");
          const products = this.selectedProducts.map(i => {
            return {
              productId: i.productId,
              name: i.name,
              price: i.price,
              quantity: i.quantity,
              discount: i.discount,
              isPercentage: i.isPercentage,
              taxRate: i.taxRate,
              productPriceTypeId: i.productPriceTypeId
            };
          });
          const requestedByVendorId =
            this.selectedServiceRequestData.vendorId ||
            (this.selectedServiceRequestData.vendor &&
              this.selectedServiceRequestData.vendor.vendorId);
          this.createQuotation({
            serviceRequestId: this.selectedServiceRequestData.serviceRequestId,
            isDetailed: true,
            isLaborCost: false,
            productMeta: products,
            total: this.total,
            discount: this.discount,
            isPercentage: this.discountMode === "percent" ? true : false,
            statusId: pendingStatus.statusId,
            requestedBy: requestedByVendorId
          }).then(async res => {
            // Prepare quotation data for printing before clearing
            const quotationData = {
              products: this.selectedProducts,
              users: this.selectedServiceRequestData.users,
              vendor: this.selectedServiceRequestData.vendor,
              quotationNumber: res.serviceRequestQuotationId,
              total: this.total,
              discount: this.discount,
              isPercentage: this.discountMode === "percent",
              updatedAt: new Date()
            };

            this.selectedProducts = [];
            this.discount = 0;
            this.selectedServiceRequestData = {};
            this.selectedServiceRequest = "";
            this.resetSale();
            this.$notify({
              message: "Quotation Added Succesfully!",
              type: "success",
              title: "Success"
            });
            // call to print quotation after generating quotation
            if (print) {
              this.printQuotation(quotationData);
            }
          });
        }
      } else if (this.quotationUser === "customer") {
        const data = await this.generateUserQuotation();
        if (isPrint) {
          print(data, "sale-quotation");
        }
      } else {
        this.$notify({
          message: "Please select service request",
          type: "danger",
          title: "Failure"
        });
      }
    },

    generateChalan() {
      if (this.$route.meta.mode === "edit-chalan") {
        this.updateServiceRequestChalanData({
          serviceRequestChalanId: this.$route.params.chalanId,
          statusId: this.chalanStatus
        })
          .then(async () => {
            // Prepare chalan data for printing before clearing
            const chalanData = {
              chalanItems: this.selectedProducts,
              users: this.selectedServiceRequestData.users,
              vendor: this.selectedServiceRequestData.vendor,
              chalanNumber: this.$route.params.chalanId,
              isInward: this.chalanType,
              total: this.total,
              updatedAt: new Date()
            };

            this.$notify({
              message: "Chalan Status Updated Succesfully!",
              type: "success",
              title: "Success"
            });

            // Ask user if they want to print
            MessageBox.confirm(
              "Chalan updated successfully! Would you like to print it?",
              "Print Chalan",
              {
                confirmButtonText: "Yes, Print",
                cancelButtonText: "No, Thanks",
                type: "info"
              }
            )
              .then(() => {
                print(chalanData, "chalan");
              })
              .catch(() => {
                // User cancelled printing, redirect to list
                this.$router.push("/chalans/list");
              });
          })
          .catch(err => {
            this.$notify({
              message: err,
              type: "danger",
              title: "Failure"
            });
          });
      } else {
        // Validate service request conditions for chalan creation
        if (
          this.chalanUser === "serviceRequest" &&
          this.selectedServiceRequestData
        ) {
          const reasons = [];
          if (this.selectedServiceRequestData.isQuotationPending === true) {
            reasons.push("Quotation is pending");
          }
          if (this.selectedServiceRequestData.isSiteVisited === false) {
            reasons.push("Site visit is not completed");
          }
          if (this.selectedServiceRequestData.customerCall === false) {
            reasons.push("Customer call is not completed");
          }

          if (reasons.length > 0) {
            this.$notify({
              message: `Cannot create chalan because: ${reasons.join(", ")}`,
              type: "danger",
              title: "Validation Error",
              duration: 5000
            });
            return; // Don't proceed with API call
          }
        }

        // Validate quantity for inward chalans
        if (this.chalanType === true) {
          for (const product of this.selectedProducts) {
            const inwardProduct = this.inwardProductList.find(
              ip => ip.productId === product.productId
            );
            if (
              inwardProduct &&
              product.quantity > inwardProduct.returnableQuantity
            ) {
              this.$notify({
                message: `Quantity for ${product.name} cannot exceed ${inwardProduct.returnableQuantity}. Available returnable quantity is ${inwardProduct.returnableQuantity}.`,
                type: "danger",
                title: "Validation Error"
              });
              return; // Don't proceed with API call
            }
          }
        }

        const products = this.selectedProducts.map(i => {
          const total = this.calculateRowTotal(i);
          return {
            productId: i.productId,
            name: i.name,
            price: i.price,
            quantity: i.quantity,
            discount: i.discount,
            isPercentage: i.isPercentage,
            taxRate: i.taxRate,
            productPriceTypeId: i.productPriceTypeId,
            total: total
          };
        });

        const vendorId =
          this.selectedServiceRequestData.vendorId ||
          (this.selectedServiceRequestData.vendor &&
            this.selectedServiceRequestData.vendor.vendorId);
        this.saveChalan({
          serviceRequestId: this.selectedServiceRequestData.serviceRequestId,
          isInward: this.chalanType,
          statusId: this.chalanStatus,
          createdBy: vendorId,
          chalanItems: products
        }).then(async res => {
          const data = snakeToCamel(res.data);
          // Prepare chalan data for printing before clearing
          const subTotal = parseFloat(this.total.toFixed(2));
          const chalanData = {
            chalanItems: products,
            users: this.selectedServiceRequestData.users,
            vendor: this.selectedServiceRequestData.vendor,
            chalanNumber: data.chalanNumber,
            isInward: this.chalanType,
            subTotal: subTotal,
            grandTotal: Math.round(this.total),
            roundedOff: this.roundOff,
            updatedAt: new Date()
          };

          this.selectedProducts = [];
          this.discount = 0;
          this.selectedServiceRequestData = {};
          this.selectedServiceRequest = "";
          this.resetSale();
          this.$notify({
            message: "Chalan Added Succesfully!",
            type: "success",
            title: "Success"
          });

          // Ask user if they want to print
          MessageBox.confirm(
            "Chalan saved successfully! Would you like to print it?",
            "Print Chalan",
            {
              confirmButtonText: "Yes, Print",
              cancelButtonText: "No, Thanks",
              type: "info"
            }
          )
            .then(() => {
              print(chalanData, "chalan");
            })
            .catch(err => {
              console.log(err);

              // User cancelled printing
            });
        });
      }
    },

    async editChalanData() {
      this.transactionType = "chalan";
      this.chalanLoader = true;
      const chalanData = await this.getChalanDetails(
        this.$route.params.chalanId
      );
      this.selectedServiceRequestData = await this.fetchServiceRequest(
        chalanData.serviceRequestId
      );
      this.chalanStatus = chalanData.statusId;
      this.chalanStatusCode = chalanData.status.code;
      this.selectedServiceRequest =
        this.selectedServiceRequestData.serviceRequestNumber +
        "(" +
        this.selectedServiceRequestData.users.firstName +
        " " +
        this.selectedServiceRequestData.users.lastName +
        "-- " +
        this.selectedServiceRequestData.vendor.firstName +
        " " +
        this.selectedServiceRequestData.vendor.lastName +
        ")";
      this.selectedChalanNumber = chalanData.chalanNumber;
      this.selectedProducts = chalanData.chalanItems;
      this.chalanType = chalanData.isInward;
      this.chalanDate = chalanData.updatedAt;
      this.chalanLoader = false;
    },

    async editQuotation() {
      this.transactionType = "quote";
      this.quotationUser = "serviceRequest";
      this.quotationLoader = true;
      const quotationData = await this.getQuotationData(
        this.$route.params.quotationId
      );
      this.selectedServiceRequestData = await this.fetchServiceRequest(
        quotationData.serviceRequestId
      );
      this.selectedServiceRequest =
        this.selectedServiceRequestData.serviceRequestNumber +
        "(" +
        this.selectedServiceRequestData.users.firstName +
        " " +
        this.selectedServiceRequestData.users.lastName +
        "-- " +
        this.selectedServiceRequestData.vendor.firstName +
        " " +
        this.selectedServiceRequestData.vendor.lastName +
        ")";
      this.discount = quotationData.discount;
      this.discountMode =
        quotationData.isPercentage === true ? "percent" : "amount";
      this.selectedProducts = quotationData.products;
      this.selectedQuotationNumber = quotationData.quotationNumber;
      this.quotationType = quotationData.type;
      this.quotationStatus = quotationData.statusId;
      this.quotationStatusCode = quotationData.status.code;
      this.quotationDate = quotationData.updatedAt;
      this.quotationLoader = false;
    },

    async generateUserQuotation() {
      if (this.quotationStatus === "" || this.quotationStatus === null) {
        this.$notify({
          message: "Please select status for quotation",
          type: "danger",
          title: "Failure"
        });
        return;
      }
      return new Promise((resolve, reject) => {
        if (this.selectedProducts.length > 0) {
          const loggedInUser = JSON.parse(window.localStorage.getItem("user"));
          const products = this.selectedProducts.map(i => {
            return {
              productId: i.productId,
              name: i.name,
              price: i.price,
              quantity: i.quantity,
              discount: i.discount,
              isPercentage: i.productDiscount === "percent" ? true : false,
              taxRate: i.taxRate,
              productPriceTypeId: i.productPriceTypeId
            };
          });
          if (this.$route.meta.mode === "edit-user-quotation") {
            this.updateUserQuotation({
              userId: this.userId,
              statusId: this.quotationStatus,
              description: this.sale.paymentNote,
              productMeta: products,
              total: this.amountDue,
              discount: this.discount,
              isPercentage: this.discountMode === "percent" ? true : false,
              createdBy: loggedInUser.userId,
              userQuotationId: this.$route.params.userQuotationId
            }).then(async res => {
              // Prepare quotation data for printing before clearing
              const userQuotationData = {
                productMeta: this.selectedProducts,
                quotationUser: this.filteredUsers.find(
                  u => u.userId === this.userId
                ),
                total: this.amountDue,
                discount: this.discount,
                isPercentage: this.discountMode === "percent",
                createdAt: new Date()
              };

              this.userId = "";
              this.quotationStatus = "";
              this.transactionType = "sale";
              this.quotationUser = "customer";
              this.$notify({
                message: "Quotation Updated!",
                type: "success",
                title: "Success"
              });

              // Ask user if they want to print
              MessageBox.confirm(
                "User Quotation updated successfully! Would you like to print it?",
                "Print User Quotation",
                {
                  confirmButtonText: "Yes, Print",
                  cancelButtonText: "No, Thanks",
                  type: "info"
                }
              )
                .then(() => {
                  print(userQuotationData, "sale-quotation");
                })
                .catch(() => {
                  // User cancelled printing
                });

              resolve(res);
              this.$router.push("/sales/quotations");
            });
          } else {
            this.createUserQuotation({
              userId: this.userId,
              statusId: this.quotationStatus,
              description: this.sale.paymentNote,
              productMeta: products,
              total: this.amountDue,
              discount: this.discount,
              isPercentage: this.discountMode === "percent" ? true : false,
              createdBy: loggedInUser.userId
            }).then(async res => {
              // Prepare quotation data for printing before clearing
              const userQuotationData = {
                productMeta: this.selectedProducts,
                quotationUser: this.filteredUsers.find(
                  u => u.userId === this.userId
                ),
                total: this.amountDue,
                discount: this.discount,
                isPercentage: this.discountMode === "percent",
                createdAt: new Date()
              };

              this.$notify({
                message: "Quotation Generated!",
                type: "success",
                title: "Success"
              });

              // Ask user if they want to print
              MessageBox.confirm(
                "User Quotation created successfully! Would you like to print it?",
                "Print User Quotation",
                {
                  confirmButtonText: "Yes, Print",
                  cancelButtonText: "No, Thanks",
                  type: "info"
                }
              )
                .then(() => {
                  print(userQuotationData, "sale-quotation");
                })
                .catch(() => {
                  // User cancelled printing
                });

              resolve(res);
              this.$router.push("/sales/quotations");
            });
          }
        } else {
          this.$notify({
            message: "Please select products",
            type: "danger",
            title: "Failure"
          });
        }
      });
    },

    async editUserQuotation() {
      this.transactionType = "quote";
      this.quotationLoader = true;
      this.quotationUser = "customer";
      const userQuotationData = await this.getUserQuotation(
        this.$route.params.userQuotationId
      );
      this.userId = userQuotationData.userId;
      this.discount = userQuotationData.discount;
      this.discountMode = userQuotationData.isPercentage ? "percent" : "amount";
      const data = await this.getUsers({
        userId: userQuotationData.userId
      });
      this.filteredUsers = data.rows;
      this.selectedProducts = userQuotationData.productMeta;
      this.quotationStatus = userQuotationData.statusId;
      this.quotationLoader = false;
    },
    filterUser(query) {
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ search: query }).then(res => {
          this.filteredUsers = res;
          this.loading = false;
        });
      } else {
        this.filteredUsers = [];
      }
    },
    async setUser() {
      if (this.sale.userId) {
        this.user = this.sale.user;
        const data = await this.getUsers({
          userId: this.sale.userId
        });
        this.filteredUsers = data.rows;
      }
    },

    filterUserByName(query) {
      this.searchedQuery = query;
      if (query.length > 2) {
        this.loading = true;
        this.searchUsers({ name: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err.status === 422) {
              this.filteredUsers = [];
            }
          });
      } else {
        this.options = [];
      }
    },
    filterUserByPhone(query) {
      this.searchedQuery = query;

      if (query.length > 2) {
        this.loading = true;
        this.searchUsers({ phone: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err.status === 422) {
              this.filteredUsers = [];
            }
          });
      } else {
        this.options = [];
      }
    },
    generateCustomerChalan() {
      // Validate quantity for customer inward chalans
      if (this.customerChalanType === true) {
        for (const product of this.selectedProducts) {
          const inwardProduct = this.inwardProductList.find(
            ip => ip.productId === product.productId
          );
          if (
            inwardProduct &&
            product.quantity > inwardProduct.returnableQuantity
          ) {
            this.$notify({
              message: `Quantity for ${product.name} cannot exceed ${inwardProduct.returnableQuantity}. Available returnable quantity is ${inwardProduct.returnableQuantity}.`,
              type: "danger",
              title: "Validation Error"
            });
            return; // Don't proceed with API call
          }
        }
      }

      const products = this.selectedProducts.map(i => {
        return {
          product_id: i.productId,
          name: i.name,
          price: i.price,
          quantity: i.quantity,
          discount: i.discount,
          is_percentage: i.isPercentage,
          tax_rate: i.taxRate,
          product_price_type_id: i.productPriceTypeId
        };
      });
      if (this.$route.meta.mode === "edit-customer-chalan") {
        apiHelper
          .call(
            "post",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/customer-chalans/${this.$route.params.customerChalanId}`,
            {
              products,
              user_id: this.userId,
              status_id: this.chalanStatus
            }
          )
          .then(async response => {
            const data = snakeToCamel(response.data);
            const user = this.filteredUsers.find(u => u.userId === this.userId);
            const subTotal = parseFloat(this.total.toFixed(2));
            const products = this.selectedProducts.map(i => {
              return {
                product_id: i.productId,
                name: i.name,
                price: i.price,
                quantity: i.quantity,
                discount: i.discount,
                is_percentage: i.isPercentage,
                tax_rate: i.taxRate,
                product_price_type_id: i.productPriceTypeId,
                total: this.calculateRowTotal(i)
              };
            });
            // Prepare chalan data for printing before clearing
            const chalanData = {
              products: products,
              user: `${user.firstName} ${user.lastName}`,
              chalanNumber: data.chalanNumber,
              is_inward: this.customerChalanType,
              subTotal: subTotal,
              grandTotal: Math.round(this.total),
              createdAt: new Date(),
              roundedOff: this.roundOff
            };

            this.selectedProducts = [];
            this.discount = 0;
            this.selectedServiceRequestData = {};
            this.selectedServiceRequest = "";
            this.chalanStatus = "";
            this.userId = "";
            this.resetSale();
            this.$notify({
              message: "Chalan Updated Succesfully!",
              type: "success",
              title: "Success"
            });

            // Ask user if they want to print
            MessageBox.confirm(
              "Customer Chalan updated successfully! Would you like to print it?",
              "Print Customer Chalan",
              {
                confirmButtonText: "Yes, Print",
                cancelButtonText: "No, Thanks",
                type: "info"
              }
            )
              .then(() => {
                print(chalanData, "customer-chalan");
              })
              .catch(() => {
                // User cancelled printing
              });
          })
          .catch(() => {
            this.$notify({
              message: "Something Went Wrong!",
              type: "danger",
              title: "error"
            });
          });
      } else {
        apiHelper
          .call(
            "post",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/customer-chalans`,
            {
              products,
              user_id: this.userId,
              status_id: this.chalanStatus,
              is_inward: this.customerChalanType
            }
          )
          .then(async response => {
            const data = snakeToCamel(response.data);

            const user = this.filteredUsers.find(u => u.userId === this.userId);

            const subTotal = parseFloat(this.total.toFixed(2));

            const products = this.selectedProducts.map(i => {
              return {
                product_id: i.productId,
                name: i.name,
                price: i.price,
                quantity: i.quantity,
                discount: i.discount,
                is_percentage: i.isPercentage,
                tax_rate: i.taxRate,
                product_price_type_id: i.productPriceTypeId,
                total: this.calculateRowTotal(i)
              };
            });

            const chalanData = {
              products: products,
              user: `${user.firstName} ${user.lastName}`,
              chalanNumber: data.chalanNumber,
              is_inward: this.customerChalanType,
              subTotal: subTotal,
              grandTotal: Math.round(this.total),
              createdAt: new Date(),
              roundedOff: this.roundOff
            };

            this.selectedProducts = [];
            this.discount = 0;
            this.selectedServiceRequestData = {};
            this.selectedServiceRequest = "";
            this.chalanStatus = "";
            this.userId = "";
            this.resetSale();
            this.$notify({
              message: "Chalan Added Succesfully!",
              type: "success",
              title: "Success"
            });

            // Ask user if they want to print
            MessageBox.confirm(
              "Customer Chalan saved successfully! Would you like to print it?",
              "Print Customer Chalan",
              {
                confirmButtonText: "Yes, Print",
                cancelButtonText: "No, Thanks",
                type: "info"
              }
            )
              .then(() => {
                print(chalanData, "customer-chalan");
              })
              .catch(() => {
                // User cancelled printing
              });
          })
          .catch(err => {
            console.log(err);

            Object.keys(err.response.data.errors).forEach(field => {
              this.$notify({
                message: err.response.data.errors[field][0],
                type: "danger",
                title: "error"
              });
            });
          });
      }
    },
    editCustomerChalan(id) {
      const url = `/api/v1/customer-chalans/${id}`;
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(async response => {
          this.transactionType = "chalan";
          this.chalanUser = "customer";
          this.chalanLoader = true;
          this.userId = response.data.userId;
          const data = await this.getUsers({
            userId: response.data.userId
          });
          this.filteredUsers = data.rows;
          this.chalanStatus = response.data.statusId;
          this.customerChalanType = response.data.is_inward;
          this.chalanStatusCode = response.data.status;
          this.selectedProducts = response.data.products;
          this.chalanLoader = false;
        });
    },

    async getCustomerChalanDetails(id) {
      const url = `/api/v1/customer-chalans/${id}`;
      try {
        const response = await apiHelper.call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}${url}`
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching customer chalan details:", error);
        this.$notify({
          message: "Error fetching chalan details for printing",
          type: "danger",
          title: "Error"
        });
        throw error;
      }
    },

    handlePrintReceipt(paymentData) {
      // Create a temporary sale object for printing
      const tempSale = {
        ...this.sale,
        productList: this.selectedProducts.map(product => ({
          name: product.name,
          quantity: product.quantity,
          rate: product.price,
          amount: this.calculateRowTotal(product)
        })),
        finalTotal: this.total, // Original total without discount
        grandTotal: this.finalAmount, // Final amount after discount and rounding
        discount: this.discount,
        isPercentage: this.discountMode === "percent",
        roundOff: this.roundOff,
        amountPaid: paymentData.totalPaid,
        paymentNote: paymentData.paymentNote,
        paymentBreakdown: paymentData.paymentBreakdown,
        userData:
          this.filteredUsers.find(u => u.userId === this.sale.userId) || {}
      };

      // Use the existing print method
      print(tempSale, "sale");

      this.$notify({
        message: "Receipt sent to printer!",
        type: "success",
        title: "Success"
      });
    },

    handleSaveSale(paymentData) {
      this.saving = true;
      this.generatingSale = true;

      // Prepare sale data with payment information
      this.sale.products = this.selectedProducts;
      this.sale.discount = this.discount;
      this.sale.paymentNote = paymentData.paymentNote;
      this.sale.amountPaid = paymentData.totalPaid;
      this.sale.total = this.finalAmount;
      this.sale.roundOff = this.roundOff;
      this.sale.paymentModes = paymentData.paymentBreakdown;

      if (this.discountMode === "amount") {
        this.sale.isPercentage = false;
      } else {
        this.sale.isPercentage = true;
      }

      // Set the primary payment mode (use the first one with amount > 0)
      const primaryPayment = paymentData.paymentBreakdown[0];
      if (primaryPayment) {
        this.sale.paymentModeId = primaryPayment.paymentModeId;
      }

      // TODO:Change this with vuex item
      const loggedInUser = JSON.parse(window.localStorage.getItem("user"));
      this.sale.createdBy = loggedInUser.userId;

      if (this.$route.meta.mode === "credit-note") {
        this.addCreditNotes()
          .then(() => {
            this.$notify({
              message: "Credit Notes Added Successfully!",
              type: "success",
              title: "Success"
            });
            this.generatingSale = false;
            this.showPaymentPopup = false;
            this.resetSale();
            this.saving = false;
          })
          .catch(err => {
            this.generatingSale = false;
            this.saving = false;
          });
      } else if (this.$route.meta.mode === "edit") {
        this.updateSale()
          .then(res => {
            this.selectedProducts = [];
            this.discount = 0;
            this.resetSale();
            this.$notify({
              message: "Sale Updated Successfully!",
              type: "success",
              title: "Success"
            });
            this.generatingSale = false;
            this.showPaymentPopup = false;
            this.$router.push("/pos");
          })
          .catch(() => {
            this.generatingSale = false;
            this.saving = false;
          });
      } else {
        this.createSale()
          .then(res => {
            this.updateChalanStatus();
            this.selectedProducts = [];
            this.discount = 0;
            this.resetSale();
            this.$notify({
              message: "Sale Saved Successfully!",
              type: "success",
              title: "Success"
            });
            if(this.$route.meta.mode === "edit-bill-request"){
              this.updateBillRequest(res.saleId);
            }
            this.generatingSale = false;
            this.showPaymentPopup = false;
            this.saving = false;
            // Print receipt after successful save
            if (res && res.saleId) {
              this.getReceipt(res.saleId);
            }
          })
          .catch(err => {
            this.generatingSale = false;
            this.saving = false;
          });
      }
    },

    updateBillRequest(saleId) {
      const url = `/api/v1/bill-requests/${this.$route.params.billRequestId}/update-with-sale`;
      apiHelper.call("post", `${endpoints.LARAVEL_BASE_URL}${url}`, {
        sale_id: saleId
      })
        .then(response => {

          this.$notify({
            message: "Bill Request Updated Successfully!",
            type: "success",
            title: "Success"
          });
        })
        .catch(err => {
          this.$notify({
            message: "Something Went Wrong!",
            type: "danger",
            title: "Error"
          });
        });
    },

    updateChalanStatus() {
      if (this.sale.chalans && this.sale.chalans.length > 0) {
        const chalanIds = this.sale.chalans.map(chalan => chalan.id);
        const url = `/api/v1/customer-chalans/update/status?chalan_ids=${chalanIds.join(
          ","
        )}`;
        apiHelper
          .call("post", `${endpoints.LARAVEL_BASE_URL}${url}`, {
            status_id: this.chalanStatus
          })
          .then(response => {
            this.sale.chalans = [];
            window.sessionStorage.removeItem("customerChalansToMerge");
          });
      }
    },

    handleMergeCustomerChalans() {
      const customerChalans = JSON.parse(
        window.sessionStorage.getItem("customerChalansToMerge") || "[]"
      );
      const url = `/api/v1/customer-chalans/merge/chalans`;
      this.sale.chalans = customerChalans;
      apiHelper
        .call("post", `${endpoints.LARAVEL_BASE_URL}${url}`, customerChalans)
        .then(response => {
          this.user = snakeToCamel(response.data.user);
          this.sale.userId = response.data.user.userId;
          this.customerPriceType = "Retail";
          this.transactionType = "sale";
          this.selectedProducts = snakeToCamel(response.data.products);
          this.discount = response.data.discount;
          this.setUser();
        });
    },
    handleConditionForInwardChalanProducts() {
      if (
        this.transactionType === "chalan" &&
        this.chalanUser === "customer" &&
        this.customerChalanType === true &&
        this.userId
      ) {
        this.selectedProducts = [];

        this.getInwardChalanProducts();
      }
    },
    async getInwardChalanProducts() {
      try {
        apiHelper
          .call(
            "get",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${this.userId}/inward-chalan/products`
          )
          .then(response => {
            this.inwardProductList = snakeToCamel(response.data);
          });
      } catch (error) {
        console.error("Error fetching inward chalans:", error);
      }
    }
  }
};
</script>
<style>
.input-group-text {
  height: 45px;
}

.product-search {
  width: 100%;
}
.cart-items:after {
  content: " ";
  display: block;
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 36px;
  background: -webkit-linear-gradient(#ffffff 0%, transparent 0%),
    -webkit-linear-gradient(135deg, #e9ebee 33.33%, transparent 33.33%) 0 0%,
    #e9ebee -webkit-linear-gradient(45deg, #e9ebee 33.33%, #ffffff 33.33%) 0 0%;
  background: -o-linear-gradient(#ffffff 0%, transparent 0%),
    -o-linear-gradient(135deg, #e9ebee 33.33%, transparent 33.33%) 0 0%,
    #e9ebee -o-linear-gradient(45deg, #e9ebee 33.33%, #ffffff 33.33%) 0 0%;
  background: -moz-linear-gradient(#ffffff 0%, transparent 0%),
    -moz-linear-gradient(135deg, #e9ebee 33.33%, transparent 33.33%) 0 0%,
    #e9ebee -moz-linear-gradient(45deg, #e9ebee 33.33%, #ffffff 33.33%) 0 0%;
  background-repeat: repeat-x;
  background-size: 0px 100%, 14px 27px, 14px 27px;
}

.cell .btn-inner--text .el-icon-error {
  cursor: pointer;
}
.el-table_1_column_4 .cell .row .col-md-6 {
  padding-right: 2px;
  padding-left: 2px;
}

.product-row {
  display: grid;
  grid-template-columns: 25% 10% 10% 10% 10% 10% 10% 10% 5%;
}
.cart {
  display: grid;
  grid-template-columns: 25% 10% 10% 10% 10% 10% 10% 10% 5%;
  background: #e2e1e1;
  font-weight: bold;
}

.cart div {
  text-align: center;
  padding: 5px;
}
.cart div:first-child {
  text-align: left;
}
.product-row .grid-item {
  padding: 3px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.grid-item .form-group {
  margin-bottom: 0px;
}

.product-row .product-name h3 {
  width: 100%;
}

.product-row .product-price .form-group .form-control {
  padding: 0px 2px;
  height: 35px;
}

.product-row .product-qty .form-group .form-control {
  height: 35px;
}

.no-rows {
  display: grid;
  text-align: center;
  padding: 10px;
}
.el-autocomplete-suggestion li.highlighted,
.el-autocomplete-suggestion li:hover {
  background-color: #aec0e6;
}
.card-header {
  padding: 0.5rem 1.5rem;
}
.card-body {
  padding: 0.5rem 0.5rem;
}
.form-control {
  padding: 2px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.product-cart {
  height: calc(100vh - 280px);
  overflow-y: auto;
}
.sale-background {
  background-color: #d0e5fb;
  border-color: #d0e5fb;
}
.quote-background {
  background-color: #f5ce9e;
  border-color: #f5ce9e;
}
.chalan-background {
  background-color: green;
  border-color: green;
}
.inward-chalan-background {
  background-color: #000000;
  border-color: #ef4d4d;
}

/* Billing Summary Styles */
.billing-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  margin: 15px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.billing-item {
  text-align: center;
  padding: 8px 4px;
  border-right: 1px solid #e9ecef;
  flex: 1;
  min-width: 0;
}

.billing-item:last-child {
  border-right: none;
}

.billing-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billing-value {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.total-value {
  color: #495057;
}

.discount-value {
  color: #fd7e14;
}

.roundoff-value {
  color: #6c757d;
}

.amount-due-row {
  margin-top: 15px;
}

.amount-due-container {
  background: linear-gradient(135deg, #28a745, #20c997);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
  border: 2px solid #28a745;
}

.amount-due-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: white;
  margin-bottom: 8px;
  letter-spacing: 1px;
  opacity: 0.9;
}

.amount-due-value {
  font-size: 32px;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin: 0;
  line-height: 1.2;
}
</style>
